import apiClient from '../clienteFebosAPI';

const RESOURCE = '/portafolio';

export const fileBinnacle = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/boletas/${payload.documentoId}/bitacora?${params}`, {
    operacionId: 'file.binacle'
  });
};
